import React from 'react';
import { Table, TableBody, TableHeader } from './InsuranceStyles';
import { PDFSafeTableHeaderCaption } from '../../CommonComponents/OPL/HtmlTable/components/PDFSafeTableHeaderCaption/PDFSafeTableHeaderCaption';
import { Text } from '../../CommonComponents/OPL/Text/Text';
import { InsuranceTableHeader } from './InsuranceTableHeader/InsuranceTableHeader';
import { useIsEmbeddedMobile } from '../../_hooks/useIsEmbeddedMobile';
import { HtmlTable } from '../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { EmptyState } from '../../CommonComponents/OPL/AsyncStates/EmptyState/EmptyState';

export const InsuranceEmpty = () => {
  const isEmbeddedMobile = useIsEmbeddedMobile();
  return (
    <>
      {isEmbeddedMobile ? (
        <HtmlTable variant="embedded" columnSpacing="small" mt="12">
          <table>
            <thead>
              <tr>
                <th>
                  <Text variant="tableHeader">Description</Text>
                </th>
                <th>
                  <Text variant="tableHeader">Premium Paid</Text>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan={2}>
                  <EmptyState />
                </td>
              </tr>
            </tbody>
          </table>
        </HtmlTable>
      ) : (
        <Table style={{ background: '#fff' }}>
          <TableHeader isFirst>
            <InsuranceTableHeader />
            <PDFSafeTableHeaderCaption colSpan={8}>
              <Text
                color="neutral.600"
                textAlign="left"
                fontSize="h6"
                fontWeight={600}
                py="16"
                px="12"
              >
                Insurance Policies
              </Text>
            </PDFSafeTableHeaderCaption>
          </TableHeader>
          <TableBody>
            <PDFSafeTableHeaderCaption colSpan={8}>
              <Text textAlign="center" py="16">
                <strong>Total Death Benefit of All Policies</strong>
              </Text>
            </PDFSafeTableHeaderCaption>
          </TableBody>
        </Table>
      )}
    </>
  );
};
